import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { CartItemPreview } from "../CartItemPreview";
import { ItemCounter } from "../../menu/ItemCounter";
import { Quantity } from ".";
import { Row, Col } from "react-bootstrap"; //ga tracker

import gaTracker from '../../../util/ga-analytics/gaTracker';
import { ecommRemove } from "../../../util";
import { AuthenticationState } from 'react-aad-msal';
import RemoveItemRewardsConfirmationModal from '../RewardRedemptionModule/RemoveItemRewardsConfirmationModal';
import { connect } from 'react-redux';
import { rewardsDuck } from '../../../ducks/rewards';

var CartItem = function CartItem(_ref) {
  var title = _ref.title,
      modNames = _ref.modNames,
      variantOptions = _ref.variantOptions,
      imgUrl = _ref.imgUrl,
      cost = _ref.cost,
      cartId = _ref.cartId,
      min = _ref.min,
      max = _ref.max,
      quantity = _ref.quantity,
      StoreProductId = _ref.StoreProductId,
      isCheckout = _ref.isCheckout,
      hideCostParent = _ref.showCost,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      product = _ref.product,
      _ref$detailLink = _ref.detailLink,
      detailLink = _ref$detailLink === void 0 ? "/detail" : _ref$detailLink,
      addOn = _ref.addOn,
      _ref$deleteItem = _ref.deleteItem,
      deleteItem = _ref$deleteItem === void 0 ? function () {
    return console.log("DELETEITEM");
  } : _ref$deleteItem,
      _ref$patchItem = _ref.patchItem,
      patchItem = _ref$patchItem === void 0 ? function (id, options, quantity) {
    return console.log(id, options, quantity, "UPDATE CART, CARTITEM");
  } : _ref$patchItem,
      _ref$stashEdit = _ref.stashEdit,
      stashEdit = _ref$stashEdit === void 0 ? function () {
    return console.log("noStashEditFound");
  } : _ref$stashEdit,
      _ref$offlineCart = _ref.offlineCart,
      offlineCart = _ref$offlineCart === void 0 ? false : _ref$offlineCart,
      _ref$rewardsBadge = _ref.rewardsBadge,
      rewardsBadge = _ref$rewardsBadge === void 0 ? null : _ref$rewardsBadge,
      rewardsState = _ref.rewardsState,
      authenticationState = _ref.authenticationState,
      _ref$removeItemReward = _ref.removeItemRewardsConfirmationFields,
      removeItemRewardsConfirmationFields = _ref$removeItemReward === void 0 ? null : _ref$removeItemReward,
      itemKey = _ref.itemKey,
      _ref$storeLastRemoved = _ref.storeLastRemovedItem,
      storeLastRemovedItem = _ref$storeLastRemoved === void 0 ? function () {
    return console.log("storeLastRemovedItem");
  } : _ref$storeLastRemoved,
      _ref$processingReward = _ref.processingRewards,
      processingRewards = _ref$processingReward === void 0 ? function () {
    return console.log("processingRewards");
  } : _ref$processingReward;

  var _useState = useState(quantity),
      _useState2 = _slicedToArray(_useState, 2),
      stateQuantity = _useState2[0],
      setQuantity = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isUpdating = _useState4[0],
      setIsUpdating = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isProcessingRewards = _useState6[0],
      setIsProcessingRewards = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showRemoveItemRewardsConfirmationModal = _useState8[0],
      setShowRemoveItemRewardsConfirmationModal = _useState8[1];

  var isIPM = title ? title.includes("Individually Packaged Meal") : false;

  if (isIPM) {
    min = 1, max = 20;
  }

  var updateCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(isUpdating || isProcessingRewards)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(e === stateQuantity)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              setIsUpdating(true);

              if (!(e < 1)) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return removeClick();

            case 8:
              window.dispatchEvent(new CustomEvent("customEventCartRemovedItem", {
                detail: {
                  product: product,
                  rewardsState: rewardsState
                }
              }));
              _context.next = 27;
              break;

            case 11:
              if (!(authenticationState === AuthenticationState.Authenticated && (rewardsState === null || rewardsState === void 0 ? void 0 : rewardsState.redeemedRewards))) {
                _context.next = 16;
                break;
              }

              _context.next = 14;
              return setIsProcessingRewards(true);

            case 14:
              _context.next = 16;
              return processingRewards(true);

            case 16:
              setQuantity(e);
              _context.prev = 17;
              _context.next = 20;
              return patchItem(cartId, options, e);

            case 20:
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](17);
              _context.next = 26;
              return processingRewards(false);

            case 26:
              setIsUpdating(false);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 22]]);
    }));

    return function updateCart(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setIsProcessingRewards(rewardsState.processingRewards);
  }, [rewardsState.processingRewards]);
  var showCost = isCheckout;

  var editClick = function editClick(e) {
    var data = {
      gtm: {
        uniqueEventId: 109,
        elementId: "cart-edit"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    return stashEdit(detailLink, StoreProductId);
  };

  var removeClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _rewardsState$redeeme;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!((rewardsState === null || rewardsState === void 0 ? void 0 : rewardsState.redeemedRewards) && (rewardsState === null || rewardsState === void 0 ? void 0 : (_rewardsState$redeeme = rewardsState.redeemedRewards) === null || _rewardsState$redeeme === void 0 ? void 0 : _rewardsState$redeeme.type) === 'recommended' && rewardsBadge && authenticationState === AuthenticationState.Authenticated)) {
                _context2.next = 5;
                break;
              }

              setIsUpdating(false);
              setShowRemoveItemRewardsConfirmationModal(true);
              _context2.next = 7;
              break;

            case 5:
              _context2.next = 7;
              return removeItem();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function removeClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  var removeItem = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return deleteItem(cartId);

            case 2:
              _context3.next = 4;
              return storeLastRemovedItem(itemKey);

            case 4:
              setIsUpdating(false);
              data = {
                gtm: {
                  uniqueEventId: 110,
                  elementId: "cart-remove"
                },
                event: 'gtm.click'
              };
              gaTracker(data);
              ecommRemove({
                item: {
                  // addon_selected: null,
                  affiliation: product.IsEat ? 'eat' : product.IsCater ? 'cater' : '',
                  // byob_item: null,
                  // coupon: null,
                  currency: 'USD',
                  discount: cost - ((product === null || product === void 0 ? void 0 : product.AdjustedPrice) || cost),
                  index: 0,
                  item_id: StoreProductId,
                  // item_list_id: null,
                  item_name: title,
                  // item_list_name: null,
                  // item_variant: variantOptions,
                  price: cost,
                  quantity: quantity,
                  sku: StoreProductId,
                  // reward_applied: null,
                  value: cost * quantity
                },
                name: title,
                id: StoreProductId,
                price: cost,
                detailLink: detailLink,
                quantity: quantity,
                catalog: product === null || product === void 0 ? void 0 : product.CatalogName
              });

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function removeItem() {
      return _ref4.apply(this, arguments);
    };
  }();

  var hideRemoveItemRewardsConfirmationModal = function hideRemoveItemRewardsConfirmationModal() {
    setShowRemoveItemRewardsConfirmationModal(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !isCheckout && /*#__PURE__*/React.createElement(RemoveItemRewardsConfirmationModal, {
    show: showRemoveItemRewardsConfirmationModal,
    hide: hideRemoveItemRewardsConfirmationModal,
    model: removeItemRewardsConfirmationFields,
    removeItem: removeItem
  }), /*#__PURE__*/React.createElement(CartItemPreview, {
    title: title,
    modNames: modNames,
    variantOptions: variantOptions,
    cost: cost,
    imgUrl: imgUrl,
    addOn: addOn,
    showCost: showCost,
    rewardsBadge: rewardsBadge,
    isCheckout: isCheckout
  }, isCheckout ? /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__modification"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-cart__item__cartcost"
  }, /*#__PURE__*/React.createElement("strong", null, "$", cost.toFixed(2)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "cb-cart-item-row"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "8",
    className: "cb-cart-cost-mobile"
  }, /*#__PURE__*/React.createElement(ItemCounter, {
    loading: isUpdating && isProcessingRewards,
    setValue: updateCart,
    counterValues: {
      min: min,
      max: max
    },
    value: stateQuantity,
    className: "cb-cart-item__counter"
  })), !showCost && /*#__PURE__*/React.createElement(Col, {
    xs: "4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-cart__item__cartcost cb-cart__cost--mobile"
  }, "$", cost.toFixed(2)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "12",
    lg: "9"
  }, !offlineCart && /*#__PURE__*/React.createElement("a", {
    className: "cb-cart__link",
    id: "cart-edit",
    onClick: editClick,
    href: "#"
  }, "Edit Item"))))));
};

var rewardsOperations = rewardsDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    storeLastRemovedItem: function storeLastRemovedItem(itemKey) {
      return dispatch(rewardsOperations.storeLastRemovedItem(itemKey));
    },
    processingRewards: function processingRewards(data) {
      return dispatch(rewardsOperations.processingRewards(data));
    }
  };
};

export default connect(null, mapDispatchToProps)(CartItem);